<script setup>
import { costOfLivingService } from "../../services/costofliving";
import { store } from '../../store.js';
import InputCurrency from "./InputCurrency.ce.vue";
import InputSelect from "./InputSelect.ce.vue";

const props = defineProps({
    survey: {
        type: Object,
        default: () => {
            return {}
        },
    },
    questionGroups: {
        type: Array,
        default: () => {
            return []
        },
    },
});

// Props are immutable, instead return object from store
const getSurveyAnswers = () => {
    if (props.survey === store.survey.full) {
        return store.survey.full.answers;
    } else {
        return store.survey.mini.answers;
    }
};

const postSurvey = () => {
    const colService = costOfLivingService(store.locale);
    colService.postSurveyAnswers(getSurveyAnswers(), props.survey.data, store.regions.levelTwo.id);
};

</script>

<template>
    <div class="grid grid-cols-1 gap-4">
        <div v-for="(questionGroup, index) in props.questionGroups" :key="index">
            <label for="{{ questionGroup.id }}" class="block mb-2 font-semibold text-wageindicator-charcoal-black">
                {{ questionGroup.label }}
            </label>

            <div v-if="questionGroup.type === 'question_group'" class="grid grid-cols-2 gap-4 mb-4"
                :class="`md:grid-cols-` + questionGroup.questions.length">

                <template v-for="(question, question_index) in questionGroup.questions" :key="question_index">
                    <template v-if="question.type === 'currency'">
                        <InputCurrency v-model="getSurveyAnswers()[question.id]" :options="{
                            currency: props.survey.data.currency,
                            locale: props.survey.getLanguage(),
                            hideCurrencySymbolOnFocus: false,
                        }" @updated-input="postSurvey" />
                    </template>
                    <template v-if="question.type === 'select'">
                        <InputSelect v-model="getSurveyAnswers()[question.id]" :options="question.options"
                            @updated-input="postSurvey" />
                    </template>
                </template>
            </div>
            <template v-if="questionGroup.type === 'text'">
                <div class="p-4 mb-4 text-sm text-white rounded-lg bg-wageindicator-blue" role="alert">
                    {{ questionGroup.text }}
                </div>
            </template>
        </div>
    </div>
</template>
